var render = function () {
  var _vm=this;
  var _h=_vm.$createElement;
  var _c=_vm._self._c||_h;

  return _c('article', [_c('activity-stage', {
    attrs: {
      "customRootContainerClass": 'build-a-keyboard full-height'
    }
  }, [_c('template', {
    slot: "instructions"
  }, [_vm._t("instructions")], 2), _c('article', {
    attrs: {
      "slot": "content"
    },
    slot: "content"
  }, [_c('div', {
    attrs: {
      "id": "dragging-content"
    }
  }, [_c('keyboard-k2-lite'), _vm.currentStep ? _c('div', {
    staticClass: "draggable-key-container"
  }) : _vm._e()], 1)])], 2)], 1);
}
var staticRenderFns = []

export { render, staticRenderFns }